import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  button: {
    display: 'flex',
    height: '40px',
    backgroundColor: '#E0FADE!important',
    color: '#357A32!important',
    padding: '12px',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '16px',
    boxShadow: 'none',
  },
}));
